import { API_BASE_URL } from "../config/apiConfig";
import DjehootyFile from "./file";
import { ThumbnailStatus, WithThumbnail } from "./thumbnail";

export default class FileInstance implements WithThumbnail {
    id: number;
    position: number;
    filename: string;
    filename_orig: string;
    importedAt: string;
    modifiedAt: string;
    agent_id: number;
    file: DjehootyFile;

    constructor(
        id: number = 0,
        position: number = 0,
        filename: string = "",
        filename_orig: string = "",
        importedAt: string = "",
        modifiedAt: string = "",
        agent_id: number = 0,
        file: DjehootyFile = new DjehootyFile(),
    ) {
        this.id = id;
        this.position = position;
        this.filename = filename;
        this.filename_orig = filename_orig;
        this.importedAt = importedAt;
        this.modifiedAt = modifiedAt;
        this.agent_id = agent_id;
        this.file = file;
    }

    loadFromJson(jsonPayload: any) {
        this.id = jsonPayload.id;
        this.position = jsonPayload.position;
        this.filename = jsonPayload.filename;
        this.filename_orig = jsonPayload.filename_orig;
        this.importedAt = jsonPayload.imported_at;
        this.modifiedAt = jsonPayload.modified_at;
        this.agent_id = jsonPayload.agent_id;

        this.file = new DjehootyFile();
        this.file.loadFromJson(jsonPayload.file);
    }

    /**
    * Gets the thumbnail status of the file instance
    * @returns ThumbnailStatus
    */
    getThumbnailStatus = (): ThumbnailStatus => {
        return this.file.getThumbnailStatus();
    }

    /**
     * Gets the thumbnail path of the file instance based on its thumbnail status and media type
     * @returns string - The thumbnail path
     */
    getThumbnailPath = (): string => {
        return this.file.getThumbnailPath();
    }
}